import { loadingModelsSelector, modelsIdsSelector } from '@/redux/models/models.selectors';
import { reactionsDataSelector } from '@/redux/reactions/reactions.selector';
import { getReactionsForModel } from '@/redux/reactions/reactions.thunks';
import { store } from '@/redux/store';
import type { NewReaction } from 'minerva-plugin-api';
import { toPluginReaction } from '@/services/pluginsManager/adapters/toPluginReaction';

const dispatchMissingReactions = (): void => {
  const state = store.getState();
  const modelIds = modelsIdsSelector(state);
  const reactionsData = reactionsDataSelector(state);
  modelIds.forEach(id => {
    if (!reactionsData[id]) {
      store.dispatch(getReactionsForModel(id));
    }
  });
};

const isReady = (): boolean => {
  const state = store.getState();
  if (loadingModelsSelector(state) !== 'succeeded') return false;
  const modelIds = modelsIdsSelector(state);
  const reactionsData = reactionsDataSelector(state);
  return modelIds.every(
    id => reactionsData[id]?.loading === 'succeeded' || reactionsData[id]?.loading === 'failed',
  );
};

const waitUntilReady = (): Promise<void> =>
  new Promise(resolve => {
    if (isReady()) {
      resolve();
      return;
    }
    const unsubscribe = store.subscribe(() => {
      if (loadingModelsSelector(store.getState()) === 'succeeded') {
        dispatchMissingReactions();
      }
      if (isReady()) {
        unsubscribe();
        resolve();
      }
    });
  });

export const getAll = async (): Promise<NewReaction[]> => {
  dispatchMissingReactions();
  await waitUntilReady();
  const reactionsData = reactionsDataSelector(store.getState());
  return Object.values(reactionsData).flatMap(modelState =>
    (modelState.data ?? []).map(toPluginReaction),
  );
};
